export default {
  itensEstoque: [],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    depositante: '',
    descricaoProduto: '',
    grupo: '',
    tipoUnidade: '',
    quantidadeAtual: '',
    order: 'descricaoProduto',
    direcao: '',
  },
  campos: {
    depositante: 'depositante',
    descricaoProduto: 'descricaoProduto',
    grupo: 'grupo',
    tipoUnidade: 'tipoUnidade',
    quantidadeAtual: 'quantidadeAtual',
  },
  colDefault: 'descricaoProduto',
  directionDefault: '',
  tableHeaders: [
    {
      text: 'depositante',
      value: 'depositante',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        module: 'estoque',
        fetch: 'fetchEstoque',
        colDef: {
          field: 'depositante',
        },
      },
    },
    {
      text: 'descricaoProduto',
      value: 'descricaoProduto',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        module: 'estoque',
        fetch: 'fetchEstoque',
        colDef: {
          field: 'descricaoProduto',
        },
      },
    },
    {
      text: 'grupo',
      value: 'grupo',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        module: 'estoque',
        fetch: 'fetchEstoque',
        colDef: {
          field: 'grupo',
        },
      },
    },
    {
      text: 'tipoUnidade',
      value: 'tipoUnidade',
    },
    {
      text: 'quantidadeAtual',
      value: 'quantidadeAtual',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        module: 'estoque',
        fetch: 'fetchEstoque',
        colDef: {
          field: 'quantidadeAtual',
        },
      },
    },
    {
      text: 'minimoEstoqueDesejado',
      value: 'situacao',
    },
  ],
  icones: {
    semConfiguracao: 'mdi-bell-cog',
    emailDesativado: 'mdi-bell-off',
    alerta: 'mdi-bell-alert',
    ok: 'mdi-bell-check',
    abaixoEsgotado: 'mdi-bell-remove',
  },
  cores: {
    none: '',
    ok: '#34D0B4',
    alertaErro: '#FD5353',
  },
};
